module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-7-d7f4af28706b7d1af958c699ca671dee.jpg";